module.exports = __webpack_public_path__ + "static/media/Spanish.9562407b.jpeg";